import { helpers, ts } from '_core';

import { DraftParams } from './types';
import { getBenchmarkTitle } from '../../common/utils/get-name';

// prepareLinearData
export const transform = (
  data: ts.types.widgets.TableData,
  isBasket: boolean,
  hasBenchmark: boolean,
  isIndexBenchmark: boolean,
  showTargetWeight?: boolean
) => {
  const newData = data.map((item) => {
    const newItem = { date: item.date } as ts.types.widgets.TableData[number];
    newItem[isBasket ? 'Basket Weights' : 'Portfolio Returns'] = item.portfolio_returns || item.return;

    const shouldShowBenchmarkData = isBasket ? showTargetWeight : true;

    if (hasBenchmark && shouldShowBenchmarkData) {
      newItem[isBasket && !isIndexBenchmark ? 'Target Weights' : 'Benchmark Returns'] = item.benchmark_returns;
      newItem['Active'] = item.active_returns;
    }

    return newItem;
  });

  return newData;
};

export const validate = (params: DraftParams) => {
  if (params.with_benchmark && !helpers.validations.validBenchmark(params.benchmark)) return ['Benchmark is invalid.'];
  return [];
};

export const getName = (
  params: DraftParams,
  context: ts.types.backtest.BacktestAnaylsisContext | ts.types.basket.BasketAnalysisContext,
  resources: ts.StoreState['resources']
) => {
  const widgetTitle = 'Cumulative Returns';

  if (params.benchmark) return getBenchmarkTitle(params.benchmark, widgetTitle, resources.universes);

  if (context?.definition?.benchmark)
    return getBenchmarkTitle(
      context.definition.benchmark as ts.types.benchmark.Benchmark,
      `${'Cumulative Returns'}`,
      resources.universes
    );

  return widgetTitle;
};
